import React from 'react'
import EllipsisLoader from '../EllipsisLoader'
import { Box } from '@mui/material'

const Loading = (props) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    data-cy="loading"
    {...props}
  >
    <EllipsisLoader align="center" />
  </Box>
)

export default Loading
